import type { PendingRedirect } from '@src/reducers/conversationalAgent';
import type { Selector } from '@types';

const selectPendingRedirect: Selector<PendingRedirect | null> = state =>
  state.conversationalAgent.pendingRedirect;

export default selectPendingRedirect;
